
import React from 'react';
import { TableRow, TableCell, TableBody } from '@/components/ui/table';

interface DataTableBodyProps {
  data: any[];
  columns: string[];
  searchTerm: string;
}

const DataTableBody: React.FC<DataTableBodyProps> = ({ data, columns, searchTerm }) => {
  // Format value for display based on its type
  const formatCellValue = (value: any): string => {
    if (value === null || value === undefined) {
      return '';
    }
    
    if (typeof value === 'object') {
      try {
        // For price_set objects common in e-commerce data
        if (value.shop_money && value.presentment_money) {
          return `${value.shop_money.amount || 0} ${value.shop_money.currency_code || ''}`;
        }
        
        // Handle arrays
        if (Array.isArray(value)) {
          return value.map(item => typeof item === 'object' ? 'Item' : String(item)).join(', ');
        }
        
        // For other objects, return a simplified string representation
        const simpleText = JSON.stringify(value);
        return simpleText.length > 100 ? simpleText.substring(0, 97) + '...' : simpleText;
      } catch (error) {
        console.error('Error formatting object value:', error);
        return '[Complex Object]';
      }
    }
    
    return String(value);
  };

  return (
    <TableBody data-testid="data-table-body">
      {data.length > 0 ? (
        data.map((row, rowIndex) => (
          <TableRow key={rowIndex} data-testid={`row-${rowIndex}`}>
            {columns.map(column => (
              <TableCell key={`${rowIndex}-${column}`} className="truncate max-w-xs" data-testid={`cell-${rowIndex}-${column}`}>
                {formatCellValue(row[column])}
              </TableCell>
            ))}
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={columns.length} className="text-center py-8 text-gray-500">
            {searchTerm ? 'No matching data found' : 'Data is syncing...'}
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};

export default DataTableBody;
